"use strict";

var _defineProperty = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _label = _interopRequireWildcard(require("./label"));
var _textfieldModule = _interopRequireDefault(require("./textfield.module.scss"));
var _field = require("./field");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
// Credit card field component
// ===========================

function formatNumber(number) {
  const parts = number.match(/.{1,4}/g);
  return parts ? parts.join(' ') : '';
}
function isNavigationKey(event) {
  if (event.shiftKey || event.metaKey || [8, 37, 38, 39, 40, 45, 36, 35].indexOf(event.keyCode) !== -1) {
    return true;
  }
  return false;
}
function isOkKey(event) {
  if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
    return false;
  }
  return true;
}
class CreditCardField extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      value: this.props.value
    });
    (0, _defineProperty2.default)(this, "onKeyDown", event => {
      if (isNavigationKey(event) || isOkKey(event)) {
        return true;
      } else {
        event.preventDefault();
      }
      return undefined;
    });
    (0, _defineProperty2.default)(this, "onChange", event => {
      this.setValueFormatted(event.target.value);
      if (this.props.onChange) {
        this.props.onChange(event);
      }
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.value && prevProps.value !== this.props.value) {
      this.setValueFormatted(this.props.value);
    }
  }
  setValueFormatted(value) {
    const unspaced = value.replace(/\s+/g, '');
    this.setState({
      value: formatNumber(unspaced)
    });
  }
  render() {
    const id = this.props.id || (0, _field.makeIdString)();
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_textfieldModule.default.CreditCardField, this.props.classNames.wrapper)
    }, /*#__PURE__*/_react.default.createElement(_label.default, {
      className: (0, _classnames.default)(this.props.classNames.label, {
        [_textfieldModule.default.errorLabel]: this.props.errorMessage
      }),
      for: id
    }, this.props.label), /*#__PURE__*/_react.default.createElement(_label.SubLabel, {
      className: (0, _classnames.default)(this.props.classNames.subLabel, {
        [_textfieldModule.default.errorLabel]: this.props.errorMessage
      })
    }, this.props.subLabel), /*#__PURE__*/_react.default.createElement("div", {
      className: _textfieldModule.default.fieldIconContainer
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "tel",
      name: this.props.name,
      autoComplete: "off",
      maxLength: 19,
      className: (0, _classnames.default)(_textfieldModule.default.field, {
        [_textfieldModule.default.fieldInvalid]: this.props.errorMessage
      }, this.props.classNames.field),
      value: this.state.value,
      id: id,
      placeholder: this.props.placeholder,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown
    })), this.props.errorMessage && /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
      message: this.props.errorMessage,
      className: this.props.classNames.errorMessage
    }));
  }
}
exports.default = CreditCardField;
CreditCardField.propTypes = _objectSpread({}, _field.textfieldPropTypes);
CreditCardField.defaultProps = {
  placeholder: 'xxxx xxxx xxxx xxxx',
  classNames: {}
};